import { useState } from 'react';
import { authApi } from '../../api/resources';
import { annonceSociete } from '../../lib/societe-ouverte';
import { C } from '../../theme/palette';

const UNIVERS = [
  ['chantier', '🏗️', 'Bâtiment'],
  ['magasin', '🛒', 'Magasin'],
];

/**
 * Le bouton Bâtiment / Magasin d'un Mix en deux sociétés.
 *
 * <p>Le Mix, ce sont deux sociétés : celle du bâtiment et celle du magasin,
 * chacune avec ses coordonnées, ses clients et sa comptabilité. Le bouton
 * ouvre l'autre société, puis recharge la page : chaque collection en mémoire
 * appartient à la société que l'on quitte, et recharger est la seule façon
 * sûre de n'en garder aucune trace.
 *
 * @param {object} props propriétés du composant
 * @param {object} props.soc fiche de la société ouverte
 * @param {{id: number, nom: string, secteur: string}} props.soeur l'autre société du Mix
 * @param {() => void} [props.recharge] rechargement de la page, remplaçable en test
 * @returns {JSX.Element} le bouton
 */
export function BasculeMix({ soc, soeur, recharge = () => window.location.reload() }) {
  const [enCours, setEnCours] = useState(false);
  const ici = soc?.secteur === 'magasin' ? 'magasin' : 'chantier';

  const bascule = async () => {
    if (enCours) return;
    setEnCours(true);
    try {
      await authApi.basculeSociete(soeur.id);
      // Les autres onglets ouverts suivent : ils se rechargent sur la même société.
      annonceSociete(soeur.id);
      recharge();
    } catch (e) {
      alert(e?.message || 'La bascule a échoué.');
      setEnCours(false);
    }
  };

  return (
    <div
      role="group"
      aria-label="Univers"
      style={{
        display: 'flex',
        background: 'rgba(255,255,255,.12)',
        borderRadius: 99,
        padding: 3,
        opacity: enCours ? 0.6 : 1,
      }}
    >
      {UNIVERS.map(([u, ic, lb]) => {
        const on = ici === u;
        return (
          <button
            key={u}
            type="button"
            aria-pressed={on}
            disabled={enCours}
            onClick={on ? undefined : bascule}
            style={{
              border: 'none',
              cursor: on ? 'default' : 'pointer',
              borderRadius: 99,
              padding: '5px 9px',
              fontSize: 9,
              fontWeight: 700,
              fontFamily: 'inherit',
              background: on ? '#fff' : 'transparent',
              color: on ? C.navy : 'rgba(255,255,255,.8)',
            }}
          >
            {ic} {lb}
          </button>
        );
      })}
    </div>
  );
}
